const computed = require('../computed/order/slider');
const _ = require('lodash');

const MULTIPLIER_MAP = {
    buildings: 1,
    city: 0.5,
    clouds: 0.4
};

const DEFAULT_VALUE = 0;
const MAX_VALUE = 1900;
const OFFSET = 475;

function asyncSetDefaultAnimation (field, state) {
    state.set(['slider', 'asyncAnimation'], true);

    setTimeout(() => {
        state.set(['slider', 'noAnimation'], true);
    }, 500);

    setTimeout(() => {
        state.set(['slider', 'positions', field], DEFAULT_VALUE);
    }, 550);

    setTimeout(() => {
        state.unset(['slider', 'noAnimation']);
        state.unset(['slider', 'asyncAnimation']);
    }, 650);
}

module.exports = {
    setComputedFields (args, state) {
        computed.promoText(state);
    },

    asyncAnimation (args, state, output) {
        const asyncAnimation = state.get(['slider', 'asyncAnimation']);

        if (asyncAnimation) {
            return;
        }

        output.no();
    },

    sliderNextView (args, state) {
        const page = state.get(['slider', 'page']);
        const positions = state.get(['slider', 'positions']);

        _.each(MULTIPLIER_MAP, (multiplier, field) => {
            const currentPosition = positions[field];

            if (((OFFSET * multiplier) + currentPosition >= MAX_VALUE)) {
                asyncSetDefaultAnimation(field, state);
            }

            state.set(['slider', 'positions', field], (OFFSET * multiplier) + currentPosition);
        });

        state.set(['slider', 'page'], (page + 1) % 5 || 1);
    }
};



// WEBPACK FOOTER //
// ./actions/order/slider.js